<template>
    <div>
        <div class="text-center">
            <h2>Dimitrios Savvas</h2>
        </div>
        <v-container class="main-text text-container">
            <div>
                <v-img :width="415" :height="415" style="float: left;" class="bradius" :src="require('@/assets/partners/Photo-D-Savvas.jpg')" />
                <p class="cv-text">
                    Dimitrios Savvas was born in Ioannina, Greece in 1961. He was awarded a Diploma in Agriculture from the Agricultural University of Athens (AUA) in 1985 and a Ph.D. degree from the University of Bonn, Germany, in 1992. From 1996 to 2006 he was affiliated with the Technological Education Institution of Epirus as an associate professor (1996-1999) and professor (1999-2006). In 2006 he became an assistant professor at the Department of Crop Science of the Agricultural University of Athens. In 2011 he was promoted to the degree of associate professor and since October 2015 he has been a full Professor in AUA. Since October 2016 he has been the Director of the Laboratory of Vegetable Production and, since September 2019, he is the Dean of the Faculty of Plant Sciences. He specializes in soilless culture, plant nutrition, water management, and applied stress physiology with emphasis on salinity and greenhouse crops. He has published over 110 papers in refereed international scientific journals (with IF) and many other papers in congress proceedings (Acta Hort.) and as book chapters. He has an h-index of 28 in Scopus and 1980 hetero-citations of his publications (updated February 2022). According to the bibliographic classification of Baas J, Boyack K, Ioannidis JPA. (2021): Updated science-wide author databases of standardized citation indicators” (<a href="https://elsevier.digitalcommonsdata.com/datasets/btchxktzyw/3" target="_blank">https://elsevier.digitalcommonsdata.com/datasets/btchxktzyw/3</a>) conducted by Stanford University for Elsevier, Professor Savvas ranks within the top 2% of scientists worldwide in his scientific field. He has been involved in many EU research projects, either as coordinator or as a member of the research team. In the last 5 years, in addition to several national research projects, he has been the coordinator of the AUA team in the European research projects LEGUME FUTURES (FP7), EUROLEGUME (FP7), TOMRES (HORIZON2020), TRUE (HORIZON2020) and VEGADAPT (PRIMA) and core member of the research team in the H2020 Project RADIANT. Since November 2022 he is coordinating the consortium of the European Innovation Project of HORIZON Europe ECONUTRI
                    (<a href="https://econutri-project.eu/" target="_blank">https://econutri-project.eu/</a>)
                    with 24 European and 6 Chinese partners, and a budget of 6,000,000 €. A detailed CV of Dimitrios Savvas is accessible via the following link:
                    <a href="http://www.ekk.aua.gr/index.php?sec=members&item=4&doc=2" target="_blank">http://www.ekk.aua.gr/index.php?sec=members&item=4&doc=2</a>).
                </p>
            </div>
        </v-container>
    </div>
</template>

<script>
    export default {
        name: 'App',
        components: {
        },
        data: () => ({
        }),
        computed: {
        }
    }
</script>
<style scoped>
.cv-card {
    border: 1px solid #D9D9D9;
    border-radius: 25px;
    text-align: center;
}
.bradius {
    border-radius: 25px;
    margin-right: 15px;
}
.cv-text {
    display: inline;
}
.main-text {
    width: 90%;
    max-width: 900px;
    margin: auto;
    color: #646464;
}

@media (max-width: 600px) {
    .bradius {
        float: none !important;
        display: block;
        margin: 0 auto 15px !important;
        max-width: 280px;
    }
}
</style>
